import { useState, useEffect, useCallback } from 'react';
import { checkSession } from '@/lib/api';

// Asks the server whether the session cookie is valid. The answer cannot be
// faked from the browser: the cookie is httpOnly and signed server-side, and
// every admin endpoint re-checks it before returning data.
//
// This hook only controls what is rendered. It is not a security boundary —
// the server is. Rendering the admin shell without a session shows an empty
// page, because every request behind it returns 401.
export function useAuth() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      await checkSession();
      setAuthenticated(true);
    } catch {
      setAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { authenticated, loading, refresh };
}
